import React from 'react';
import { Grid } from '@mui/material';

interface IProps {
    children?: React.ReactNode;
}

const GridContainer = ({ children }: IProps) => {
    return (
        <Grid
            container
            sx={{
                maxWidth: 1280,
                paddingTop: 2,
                paddingBottom: { xs: 2, md: 4 },
                px: "8px",
                position: 'relative',
                height: "100%",
                width: 'calc(100% - 16px)',
                justifyContent: 'center',
            }}
            spacing={{ xs: 2, md: 4 }}
        >
            {children}
        </Grid>
    );
};

export default GridContainer;
